import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";

// L'index.html public est désormais une page statique HTML/SEO. On ne charge
// plus le SPA React au home — on ne monte que le widget configurateur + les
// modales (devis / suivi de commande) sur leurs points de montage.
// Sur les routes applicatives (/admin, /success, /cancel, /track/:token),
// la page statique est masquée et React reprend la main.

const APP_ROUTES = ["/admin", "/success", "/cancel", "/track"];
const path = window.location.pathname;
const isAppRoute = APP_ROUTES.some(
  (r) => path === r || path.startsWith(`${r}/`),
);

if (isAppRoute) {
  // Mode SPA : on cache la page statique et on rend l'application complète.
  const staticSite = document.getElementById("static-site");
  if (staticSite) staticSite.style.display = "none";

  let mount = document.getElementById("root");
  if (!mount) {
    mount = document.createElement("div");
    mount.id = "root";
    document.body.appendChild(mount);
  }

  // Chargement à la demande du SPA pour que la home (statique) ne charge
  // jamais ce code dans son bundle initial.
  import("@/App").then(({ default: App }) => {
    ReactDOM.createRoot(mount).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    );
  });
} else {
  // Mode page statique : le HTML est déjà rendu, on monte uniquement les îlots.
  const configMount = document.getElementById("configurator-app");
  if (configMount) {
    import("@/widgets/HomeWidgets").then(({ default: HomeWidgets }) => {
      ReactDOM.createRoot(configMount).render(
        <React.StrictMode>
          <HomeWidgets />
        </React.StrictMode>,
      );
    });
  }
}
